import distance from '@turf/distance';
import { point } from '@turf/helpers';
import { StationMasterType } from '../context/MasterContextProvider';

const MAX_DISTANCE_TO_STATION = 5; //最寄り電停までの距離の許容範囲(km)

// ユーザー位置情報から、一定距離内にある最寄りの電停番号を返す
export const findNearestStation = (
  stations: Array<StationMasterType>,
  user_latitude: number,
  user_longtitude: number
): string | null => {
  let nearestStationNo = null;
  let minDist = Infinity;
  stations.forEach((station) => {
    const user_position = point([user_latitude, user_longtitude].reverse());
    const station_position = point(
      [station.latitude, station.longtitude].reverse()
    );
    const dist = distance(user_position, station_position, {
      units: 'kilometers'
    });
    if (dist < minDist && dist < MAX_DISTANCE_TO_STATION) {
      nearestStationNo = station.station_no;
      minDist = dist;
    }
  });

  return nearestStationNo;
};
